import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2852a5cc: FaireBrandEntity = {
  token: "b_2852a5cc",
  type: "brand",
  name: "Jack Rabbit Creations",
  avatarUrl:
    "https://cdn.faire.com/fastly/52a9e49b29ea8724b95fc6ca9ee5f38f7d7c202080155cffb6b0ed49834a2ac2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/64c0103053037d28cbb0167d9ec5b35311704168b22ea30196592c173daddca4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/52a9e49b29ea8724b95fc6ca9ee5f38f7d7c202080155cffb6b0ed49834a2ac2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/64c0103053037d28cbb0167d9ec5b35311704168b22ea30196592c173daddca4.jpeg",
  location: "Atlanta, GA, USA",
  minimumOrderDollars: 250,
  rating: 4.9,
  reviewCount: 318,
  isInsider: true,
  description:
    "Jack Rabbit Creations is a small, woman-owned company founded in 1995. Our heirloom toys are powered by imagination, not batteries. Our custom artwork and unique designs all begin as a spark in the imagination of one of our team members and are created to encourage hours of imaginative, interactive play.\n\nWe care about our families - and yours! So our toys are made of natural materials like FSC-certified wood, tin, and cotton. They all meet USA Toy Safety Standards and conform to ASTM and CPSIA guidelines. As moms ourselves, we are committed to the highest standards of quality, safety, durability, and sustainability. We love all of our customers and hope our heirloom toys bring happiness for this generation and beyond.\n\nWe hope the world of Jack Rabbit Creations fills you with joy!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:02.596Z",
    importedBy: "entity-db-cli",
  },
};
